// api/getExistingObject.js
import axios from "axios";
import store from "../redux/store";
import { showToastAction } from "../redux/toastSlice";

export default async function getExistingObject(projectName, formName, documentId) {
    try {
        const res = await axios.get(`/project/${projectName}/${formName}/Document/validated/${documentId}`);

        // Normaliser : si data est un tableau, on prend le premier élément
        if (Array.isArray(res.data?.data) && res.data.data.length > 0) {
            return res.data.data[0];
        }

        if (res.data?.data && typeof res.data.data === 'object') {
            return res.data.data;
        }

        return null;
    } catch (err) {
        store.dispatch(showToastAction({
            message: err.response?.data?.errorMessage ?? "Error fetching object",
            showToast: true
        }));
        return null;
    }
}
